export default __webpack_public_path__ + "static/invite-5d66943b094a2fabc2dd465ca0dc127d.jpg";